var map = {
	"./de-DE.json": 93250,
	"./en-GB.json": 82232,
	"./en-US.json": 62657,
	"./es-ES.json": 95052,
	"./fr-CA.json": 74968,
	"./fr-FR.json": 20424,
	"./it-IT.json": 98882,
	"./ja-JP.json": 7585,
	"./ro-RO.json": 32642
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4126;